import api from './axiosConfig';
import { handleApiError } from './errorHandler';

export const itemFamilyAPI = {
    create: async (familyData) => {
        try {
            const { data } = await api.post('/api/item-families/create/', familyData);
            return data;
        } catch (error) {
            handleApiError(error, 'Create item family error:');
        }
    },
    getAll: async (page, pageSize, searchTerm) => {
        try {
            const { data } = await api.get('/api/item-families/', {
                params: { page, pageSize, searchTerm }
            });
            return data;
        } catch (error) {
            handleApiError(error, 'Get all item families error:');
        }
    },
    getById: async (id) => {
        try {
            const { data } = await api.get(`/api/item-families/${id}/`);
            return data;
        } catch (error) {
            handleApiError(error, 'Get item family by id error:');
        }
    },
    update: async (id, familyData) => {
        try {
            const { data } = await api.put(`/api/item-families/update/${id}/`, familyData);
            return data;
        } catch (error) {
            handleApiError(error, 'Update item family error:');
        }
    },
    delete: async (id) => {
        try {
            const { data } = await api.delete(`/api/item-families/delete/${id}/`);
            return data;
        } catch (error) {
            handleApiError(error, 'Delete item family error:');
        }
    },
    addItem: async (familyId, stockItemId) => {
        try {
            const { data } = await api.post(`/api/item-families/${familyId}/add-item/`, {
                stock_item_id: stockItemId
            });
            return data;
        } catch (error) {
            handleApiError(error, 'Add item to family error:');
        }
    },
    removeItem: async (familyId, stockItemId) => {
        try {
            const { data } = await api.post(`/api/item-families/${familyId}/remove-item/`, {
                stock_item_id: stockItemId
            });
            return data;
        } catch (error) {
            handleApiError(error, 'Remove item from family error:');
        }
    }
};
